export const matchKeys = {
	teamPlayers: (organizationUuid: string, teamLeagueUuid: string, teamUuid: string) =>
		[`TEAM_PLAYERS`, organizationUuid, teamLeagueUuid, teamUuid] as const,
	matches: (matchId: string) => [`MATCHES`, matchId] as const,
	teamPlayersInfo: (organizationUuid: string, teamLeagueUuid: string, teamUuid: string, search: string) =>
		[`TEAM_PLAYERS_INFO`, organizationUuid, teamLeagueUuid, teamUuid, search] as const
} as const;
